import * as moment from "moment";

export class DateTimeUtilities {
  public static getLocalDateAndTimeString(utcDateString: string, timezoneOffset: number): string {
    const utcDate = new Date(this.getIEFriendlyDate(utcDateString));
    const tzDate = this.getDateWithOffset(utcDate, timezoneOffset);
    return `${moment(tzDate, [moment.ISO_8601, moment.RFC_2822, "MM/DD/YYYY h:mm:ss A Z"]).format("ddd MMM D, YYYY h:mm A")}`;
  }

  public static getLocalDateAndTimeStringMobile(date: Date, timezoneOffset: number): string {
    const tzDate = this.getDateWithOffset(date, timezoneOffset);
    return `${moment(tzDate, [moment.ISO_8601, moment.RFC_2822, "MM/DD/YYYY h:mm:ss A Z"]).format("M/D/YY h:mm A")}`;
  }

  public static getLocaleShortTimeFromDate(date: Date, includeMeridiems: boolean = true): string {
    return DateTimeUtilities.getShortTimeFromDate(date, new Date().getTimezoneOffset(), includeMeridiems);
  }

  public static getShortTimeFromDate(date: Date, timezoneOffset: number, includeMeridiems: boolean = true): string {
    const newDate = this.getDateWithOffset(date, timezoneOffset);

    let time: string = newDate
      .toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit"
      })
      // GOOD GOD IE!!!! https://www.csgpro.com/blog/2016/08/a-bad-date-with-internet-explorer-11-trouble-with-new-unicode-characters-in-javascript-date-strings
      .replace(/[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g, "");

    if (!includeMeridiems) {
      // We can't guarantee that the client uses meridiems so using
      // a substring can easily break things
      time = time
        .replace(/\s*PM/, "")
        .replace(/\s*AM/, "")
        .replace(/^\s*0/, "");
    }
    return time;
  }

  public static getIEFriendlyDate(dateString: string) {
    const newDateString = dateString.replace(/:(?=\d\d$)/, "");
    return new Date(newDateString);
  }

  public static getShortTimeFromTime(time: string, timezoneOffset: number, includeMeridiems: boolean = true): string {
    const date = this.getDateFromTime(time);
    return this.getShortTimeFromDate(date, timezoneOffset, includeMeridiems);
  }

  public static updateDateTimeTimeZone(dateTime: Date, timezoneOffset: number): string {
    return moment(dateTime, [moment.ISO_8601, moment.RFC_2822, "MM/DD/YYYY h:mm:ss A Z"])
      .utcOffset(timezoneOffset * -1, true)
      .format();
  }

  public static getWeekdayCodeNumber(dayCode: string): number {
    switch (dayCode) {
      case "SUN":
        return 1;
      case "MON":
        return 2;
      case "TUE":
        return 3;
      case "WED":
        return 4;
      case "THU":
        return 5;
      case "FRI":
        return 6;
      case "SAT":
        return 7;
      default:
        return -1;
    }
  }

  public static getDaysBetween(fromDate: Date, toDate: Date): number {
    const millisecondsPerDay = 24 * 3600 * 1000;
    const timeDiff = Math.abs(toDate.getTime() - fromDate.getTime());
    return Math.round(timeDiff / millisecondsPerDay);
  }

  public static getClientOffsetISO(): string {
    const offsetTotalInMinutes = new Date().getTimezoneOffset(); // today
    let offSetHours = Math.abs(offsetTotalInMinutes / 60);
    let offsetMin = Math.abs(offsetTotalInMinutes % 60);
    let offSetHoursString = "";
    let offSetMinutesString = "";
    let isoOffset = "";

    if (offSetHours < 10) {
      offSetHoursString = "0" + offSetHours;
    }

    if (offsetMin < 10) {
      offSetMinutesString = "0" + offsetMin;
    }

    // Add an opposite sign to the offset
    // If offset is 0, it means timezone is UTC
    if (offsetTotalInMinutes < 0) {
      isoOffset = "+" + offSetHoursString + ":" + offSetMinutesString;
    } else if (offsetTotalInMinutes > 0) {
      isoOffset = "-" + offSetHoursString + ":" + offSetMinutesString;
    } else if (offsetTotalInMinutes == 0) {
      isoOffset = "Z";
    }

    return isoOffset;
  }

  public static getClientOffsetISOForDate(someDate: Date): string {
    const offsetTotalInMinutes = new Date(someDate).getTimezoneOffset(); // future appt day
    let offSetHours = Math.abs(offsetTotalInMinutes / 60);
    let offsetMin = Math.abs(offsetTotalInMinutes % 60);
    let offSetHoursString = "";
    let offSetMinutesString = "";
    let isoOffset = "";

    if (offSetHours < 10) {
      offSetHoursString = "0" + offSetHours;
    }

    if (offsetMin < 10) {
      offSetMinutesString = "0" + offsetMin;
    }

    // Add an opposite sign to the offset
    // If offset is 0, it means timezone is UTC
    if (offsetTotalInMinutes < 0) {
      isoOffset = "+" + offSetHoursString + ":" + offSetMinutesString;
    } else if (offsetTotalInMinutes > 0) {
      isoOffset = "-" + offSetHoursString + ":" + offSetMinutesString;
    } else if (offsetTotalInMinutes == 0) {
      isoOffset = "Z";
    }
    console.log(`client offset for date ${someDate}: ${isoOffset} `);
    return isoOffset;
  }

  private static getDateWithOffset(date: Date, timezoneOffset: number): Date {
    const currentOffset = date.getTimezoneOffset();
    const minutesToAdd = currentOffset - timezoneOffset;
    return new Date(date.getTime() + minutesToAdd * 60000);
  }

  private static getDateFromTime(time: string) {
    const today = new Date();
    const timeParts = time.split(":");
    const hour = parseInt(timeParts[0], 10);
    const minutes = parseInt(timeParts[1], 10);
    return new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate(), hour, minutes));
  }
}
